import React from 'react';

// React 19 natively hoists <title>/<meta>/<link> rendered anywhere in the
// tree up into <head>, so per-route metadata needs no extra dependency.
// Note: this is a client-rendered CRA app, so these tags appear after JS runs.
// The static tags in public/index.html remain the crawler-safe baseline.
const SITE_URL = 'https://moran-weinberger.co.il';

export default function Seo({
  title,
  description,
  path = '/',
  image = '/og-image.jpg',
  noindex = false,
}) {
  const url = SITE_URL + path;
  const img = image.startsWith('http') ? image : SITE_URL + image;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </>
  );
}
